import ServiceSchemaError from '@/modules/core/models/errors/ServiceSchemaError'

export class BillingCyclesModality {
  id: string
  textInFilter: string
  textInPrice: string
  discountText: string
  default?: boolean

  constructor(data: BillingCyclesModality) {
    if (!data.id) {
      throw new ServiceSchemaError({ message: 'Error en la propiedad "id"' })
    }

    this.id = data.id
    this.textInFilter = data.textInFilter
    this.textInPrice = data.textInPrice ? data.textInPrice.trim() : ''
    this.discountText = data.discountText
    this.default = data.default ?? false
  }
}

export class BillingCycles {
  monthly?: BillingCyclesModality
  quarterly?: BillingCyclesModality
  semiannual?: BillingCyclesModality
  annual?: BillingCyclesModality
  unique?: BillingCyclesModality

  constructor(data: BillingCycles) {
    if (data.monthly) this.monthly = new BillingCyclesModality(data.monthly)
    if (data.quarterly) this.quarterly = new BillingCyclesModality(data.quarterly)
    if (data.semiannual) this.semiannual = new BillingCyclesModality(data.semiannual)
    if (data.annual) this.annual = new BillingCyclesModality(data.annual)
    if (data.unique) this.unique = new BillingCyclesModality(data.unique)
  }
}
